import Loadable from '@/common/lazy/Loadable';
import imports from '@/routing/imports';
import SubscribedMatchLoader from '../subscriptions/SubscribedMatchLoader';

const SubscribedMatchesList = Loadable({
    loader: imports.notifications,
    loading: SubscribedMatchLoader,
    exp: Exp => Exp.SubscribedMatchesList
});
export default SubscribedMatchesList;
